import { useState } from 'react';
import { useSelector } from 'react-redux';
import slice from 'ramda/src/slice';
import Button from '@components/@core/AnimatedButton';
import EditDropdown from '@components/EditDropdown';
import Filter from '@components/@core/Filter';
import Thumbnail from '@components/@core/Thumbnail';
import Settings from '@components/@core/Settings';
import { LibraryCardDetailMenu } from '~/services/config';
import moment from 'moment';
import Module from './Module';
import AppActions from '~/actions/app';

const Detail = ({ data, onCardMenu, onChildMenu }) => {
    const [page, setPage] = useState(1);
    const [per, setPer] = useState(25);
    const role = useSelector((state) => state.app.app_role_id);
    const authors = useSelector((state) => state.app.authors);
    const departments = useSelector((state) => state.app.departments);
    const competencies = useSelector((state) => state.app.competencies);
    const categories = useSelector((state) => state.app.categories);

    const modules = data.children || [];
    const from = (page - 1) * per;
    const to = page * per;
    const selected = slice(from, to, modules);

    const handleReadMore = (data) => {
        dispatch(
            AppActions.modalRequest({
                type: 'Read More',
                data: { before: { data: data } },
            })
        );
    };

    const settings = [
        { name: 'Author', id: [data.author_id], options: authors },
        { name: 'Departments', id: data.data.department, options: departments },
        { name: 'Competencies', id: data.data.compentency, options: competencies },
        { name: 'Categories', id: data.data.category, options: categories },
    ];

    const stats = [
        { name: 'Created', value: moment(data?.created_at).format('MMM DD, YY') || null },
        { name: 'Created By', value: data?.created_by || 'Na' },
        { name: 'Last Edited', value: moment(data?.updated_at).format('MMM DD, YY') || null },
        { name: 'Last edits by', value: data?.edited_by || 'Na' },
        { name: 'Assigned', value: data?.assigned || 'Na' },
    ];

    return (
        <>
            <Filter back="all courses" />
            <div className="library-course-card border-5">
                <div className="detail-content">
                    <div className="d-flex jc-between">
                        <p className="dsl-b22 bold" data-cy="courseDetailTitle">
                            Course
                        </p>
                        <div className="desktop-block">
                            <EditDropdown options={LibraryCardDetailMenu[role]} onChange={onCardMenu} />
                        </div>
                    </div>
                    <div className="d-flex jc-between ssm-column mb-4">
                        <div className="ssm-100 w-50 w-sm-100 mb-3">
                            <div className="d-flex ai-center ps-1 mb-3">
                                <div className="career-text dsl-b12">Name</div>
                                <p className="dsl-b16 text-400 truncate-one mb-0 ps-2">{data?.data?.en?.name || 'N/A'}</p>
                            </div>
                            <div className="d-flex ai-start ps-1 mb-3">
                                <p className="career-text dsl-b12 pt-2 m-0">Description</p>
                                <p className="dsl-b16 word-break mb-0 ps-2">
                                    {data?.data?.en?.description?.substring(0, 50) || 'N/A'}
                                    {(data?.data?.en?.description?.length || 0) > 50 && (
                                        <Button name="Read more" type="link" onClick={() => handleReadMore(data.data.en.description.length)} />
                                    )}
                                </p>
                            </div>
                            <div className="d-flex ai-start ps-1">
                                <p className="career-text dsl-b12 pt-2 m-0">Learning Objectives</p>
                                <p className="dsl-b16 word-break mb-0 ps-2">
                                    {data?.data?.objectives?.map((item, index) => (
                                        <div className="d-flex mt-1" key={index}>
                                            <span className="dsl-b16 w-100 pt-1">
                                                {index + 1} {item}
                                            </span>
                                        </div>
                                    ))}
                                </p>
                            </div>
                        </div>
                        <div className="ssm-100 w-40 w-sm-100">
                            <Thumbnail source={data.thumbnail || data.data.thumb_url} size="medium" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="library-course-card mt-3 border-5">
                <div className="modules-content">
                    <div className="modules-header">
                        <span className="dsl-b18 bold">Modules Attached</span>
                    </div>
                    <Module data={selected} role={role} onMenu={onChildMenu} menu={false} />
                </div>
            </div>
            <Settings values={settings} stats={stats} />
        </>
    );
};

export default Detail;
